import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { ISupportCaseListItem, ListModel, ListQueryParam, queryKeys } from '../../../shared';

async function getSupportCases(
    params: ListQueryParam,
    organisation?: string,
    onGetErrorMessage?: string,
): Promise<ListModel<ISupportCaseListItem>> {
    const { data } = await axios.get('/support-api/support-cases', {
        params: { ...params, organisationId: organisation },
        errorMessage: onGetErrorMessage,
    });
    return data;
}

export const useGetSupportCases = (params: ListQueryParam, enabled: boolean, organisation?: string) => {
    const { t } = useTranslation();

    return useQuery<ListModel<ISupportCaseListItem>, AxiosError>({
        queryKey: [queryKeys.SUPPORT_CASES, params, { organisation: organisation }],
        queryFn: () => getSupportCases(params, organisation, t('getSupportCasesError')),
        enabled,
    });
};
